var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleBatteryWarningSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81641 0.5H6.1875C6.20077 0.5 6.21612 0.50494 6.22852 0.517578C6.24124 0.530549 6.25 0.550802 6.25 0.573242V2.79395H11.75V0.573242C11.75 0.5508 11.7588 0.530548 11.7715 0.517578C11.7839 0.504941 11.7992 0.5 11.8125 0.5H15.1875C15.1942 0.49997 15.2013 0.501125 15.208 0.503906C15.2148 0.506713 15.2214 0.5114 15.2275 0.517578C15.2338 0.52392 15.2392 0.532385 15.2432 0.541992C15.2471 0.551594 15.25 0.5623 15.25 0.573242V2.79395H16.875C16.9557 2.79397 17.0362 2.81106 17.1113 2.84277C17.1863 2.87451 17.2551 2.92097 17.3135 2.98047C17.3719 3.04008 17.419 3.1113 17.4512 3.19043C17.4833 3.26963 17.5 3.35513 17.5 3.44141V12.6172C17.5 12.7034 17.4833 12.789 17.4512 12.8682C17.419 12.9473 17.3719 13.0185 17.3135 13.0781C17.2551 13.1377 17.1863 13.1851 17.1113 13.2168C17.0362 13.2485 16.9557 13.2646 16.875 13.2646H1.125C0.962413 13.2646 0.804504 13.1984 0.686523 13.0781C0.568325 12.9575 0.5 12.7918 0.5 12.6172V3.44141L0.512695 3.3125C0.537447 3.18664 0.597829 3.0709 0.686523 2.98047C0.804504 2.86018 0.962414 2.79399 1.125 2.79395H2.75391V0.573242C2.75391 0.550801 2.76267 0.530549 2.77539 0.517578C2.78777 0.505024 2.80317 0.5 2.81641 0.5Z",
    stroke: "#e88f25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17578 7.14844H6.88166",
    stroke: "#e88f25",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5879 7.14844H14.2938",
    stroke: "#e88f25",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4414 9V5.29412",
    stroke: "#e88f25",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleBatteryWarningSmall);
export default __webpack_public_path__ + "static/media/ic_tele_battery_warning_small.a432b080cb6b962c7f878a9a04bd8c26.svg";
export { ForwardRef as ReactComponent };